import { render, staticRenderFns } from "./NewAssociation.vue?vue&type=template&id=23a6173c&"
import script from "./NewAssociation.vue?vue&type=script&lang=js&"
export * from "./NewAssociation.vue?vue&type=script&lang=js&"
import style0 from "./NewAssociation.vue?vue&type=style&index=0&id=23a6173c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports